// extracted by mini-css-extract-plugin
module.exports = {"container":"CompareModal_container__z_AGK","productsContainer":"CompareModal_productsContainer__XA5d3","compareContainer":"CompareModal_compareContainer__2WBjP"};